import React from "react";

import { Modal } from "new-components/modals/Modal";
import { Typography } from "new-components/typography/Typography";

export interface DetectorGroup {
  id: string;
  name: string;
}

interface QueryEditWarningModalProps {
  dialogOpen: boolean;
  onClose: () => void;
}

export function QueryEditWarningModal(props: QueryEditWarningModalProps) {
  const { dialogOpen, onClose } = props;

  const handleAccept = () => {
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      size="small"
      open={dialogOpen}
      onClose={handleClose}
      title="Model may need to be reset"
      body={[
        <Typography className="mx-auto mb-6">
          If you&apos;re making substantial changes to this query, please reset the detector. Data generated until now
          may be inaccurate. For minor changes, proceed.
        </Typography>,
      ]}
      confirmationButtonTitle="Accept"
      onConfirmation={handleAccept}
    />
  );
}
